import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { HiLocationMarker } from "react-icons/hi";
import { MdCall, MdMessage } from "react-icons/md";

const Footer = () => {
  return (
    <div className="bg-gray-800 text-white px-5 relative z-50">
      <section className="max-w-[1200px] mx-auto text-white">
        <div className="grid md:grid-cols-3 py-5">
          {/* first col */}
          <div className="py-8 px-2 md:px-4">
            <h1 className="text-xl sm:text-3xl font-bold sm:text-left text-justify mb-3">
              Zemen Tech
            </h1>
            <p className=" pt-4">
              Mobile Apps, Web system <br />– Your Perfect First Choose
            </p>
            <a
              href="https://t.me/c/2290752889/2"
              target="_blank"
              className="inline-block bg-[#3d2517] py-2 px-4 mt-5 text-sm rounded-full"
            >
              Visit our Telegram Channel
            </a>
          </div>
          {/* second col */}
          <div className="grid grid-cols-2 sm:grid-cols-3 col-span-2 md:pl-10">
            <div>
              <div className="py-8 px-4">
                <h1 className="text-xl font-bold mb-3">Quick Links</h1>
                <ul className="flex flex-col gap-3">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/about-us">About</a>
                  </li>
                  <li>
                    <a href="/services">Services</a>
                  </li>
                  <li>
                    <a href="/about-us">FAQs</a>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div className="py-8 px-4">
                <h1 className="text-xl font-bold mb-3">Product</h1>
                <ul className="flex flex-col gap-3">
                  <li>
                    <a href="https://zemen.tech/">Bus System</a>
                  </li>
                  <li>
                    <a href="http://kuku.et/">E-commerce</a>
                  </li>
                  <li>
                    <a href="https://horizon211.odoo.com/">ERP System</a>
                  </li>
                  <li>
                    <a href="https://horizon211.odoo.com/">E-learning</a>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div className="py-8 px-4">
                <h1 className="text-xl font-bold mb-2">Contact Us</h1>
              </div>
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <HiLocationMarker />
                  <p>Debre Markos, Ethiopia</p>
                </div>
                <div className="flex items-center gap-2 mt-3">
                  <MdMessage />
                  <p>zementechno@gmail.com</p>
                </div>
                <div className="flex items-center gap-3 mt-3">
                  <MdCall />
                  <p>+251 912 152 414</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* bottom section */}
        <div className="">
          <div className="flex flex-col md:flex-row md:justify-between justify-center items-center py-4 gap-2 border-t-2 border-gray-400">
            <span className="text-sm text-gray-400">
              copyright &copy; 2025 by Zemen
            </span>
            <div className="flex items-center justify-center gap-4 pb-4">
              <a href="https://t.me/c/2290752889/2">
                <FaInstagram className="text-4xl" />
              </a>
              <a href="https://t.me/c/2290752889/2">
                <FaFacebook className="text-4xl" />
              </a>
              <a href="https://t.me/c/2290752889/2">
                <FaLinkedin className="text-4xl" />
              </a>
            </div>
            <span className="text-sm text-gray-400">
              <ul className="flex gap-3">
                <li>Privacy Policy</li>
                <li>Terms & Conditions</li>
              </ul>
            </span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
